(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ags-photo-carousel"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('ags-photo-carousel')) customElements.define('ags-photo-carousel', class extends HTMLElement {
  connectedCallback() {
    if (this.ready) return;
    this.ready = true;
    const desktopMotion = matchMedia('(min-width: 1024px)');
    const track = this.querySelector('.ags-photo-carousel__track');
    const slides = Array.from(track.children);
    if (slides.length < 2) return;
    const clone = slide => {
      const copy = slide.cloneNode(true);
      copy.dataset.agsClone = 'true';
      copy.removeAttribute('data-shopify-editor-block');
      copy.setAttribute('aria-hidden', 'true');
      copy.querySelectorAll('[id]').forEach(el => el.removeAttribute('id'));
      return copy;
    };
    const before = document.createDocumentFragment();
    const after = document.createDocumentFragment();
    slides.forEach(slide => { before.append(clone(slide)); after.append(clone(slide)); });
    track.prepend(before);
    track.append(after);
    let span = 0;
    let position = 0;
    let lastTime = 0;
    const normalize = value => span + ((value - span) % span + span) % span;
    const measure = () => {
      const next = slides[0].offsetLeft - track.firstElementChild.offsetLeft;
      if (!next) return;
      const fraction = span ? ((position - span) % span + span) % span / span : 0;
      span = next;
      position = span + fraction * span;
      track.scrollLeft = position;
    };
    this.observer = new ResizeObserver(measure);
    this.observer.observe(track);
    measure();
    const tick = now => {
      const delta = lastTime ? Math.min(now - lastTime, 64) : 0;
      lastTime = now;
      if (span && !document.hidden) {
        if (Math.abs(track.scrollLeft - position) > 2) position = track.scrollLeft;
        position = normalize(position + (desktopMotion.matches ? 545.4 : 228.6) * delta / 1000);
        track.scrollLeft = position;
      }
      this.frame = requestAnimationFrame(tick);
    };
    this.frame = requestAnimationFrame(tick);

  }
  disconnectedCallback() {
    cancelAnimationFrame(this.frame);
    if (this.observer) this.observer.disconnect();
    this.querySelectorAll('[data-ags-clone]').forEach(el => el.remove());
    this.ready = false;
  }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ags-product-announcements"]) return;
  try {
    
(() => {
  const init = () => {
    const bar = document.getElementById('ags-product-announcements');
    if (!bar || bar.dataset.ready) return;
    bar.dataset.ready = 'true';
    const slides = Array.from(bar.querySelectorAll('p'));
    let index = 0;
    let paused = matchMedia('(prefers-reduced-motion: reduce)').matches;
    let timer;
    const show = (step) => {
      index = (index + step + slides.length) % slides.length;
      slides.forEach((slide, i) => { slide.hidden = i !== index; });
    };
    const stop = () => clearInterval(timer);
    const start = () => { stop(); if (!paused) timer = setInterval(() => {
      if (!bar.isConnected) { stop(); return; }
      if (!document.hidden) show(1);
    }, 4000); };
    bar.querySelector('[data-ags-prev]').addEventListener('click', () => { show(-1); start(); });
    bar.querySelector('[data-ags-next]').addEventListener('click', () => { show(1); start(); });
    bar.addEventListener('mouseenter', stop);
    bar.addEventListener('mouseleave', start);
    bar.addEventListener('focusin', stop);
    bar.addEventListener('focusout', start);
    start();
  };
  init();
  document.addEventListener('shopify:section:load', init);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
